
<div class="language-picker">
  <ul class="language-list">
    <ng-container *ngFor="let language of supportedLanguages">
      <li [ngClass]="{ 'active' : language?.code == selectedLanguage?.code }">
        <a class="language-list_item" (click)="selectLanguage(language)">
          <span class="flag flag-{{ language?.code }}" title="{{ language?.name | translate }}"></span>
        </a>
      </li>
    </ng-container>
  </ul>
</div>

<!--
  SK: old language switcher
<div class="language-picker" [ngClass]="{'-active': isActive}">

  <a
    class="language-picker_item -selected"
    *ngIf="selectedLanguage"
    (click)="activatePicker($event)">
    <span class="flag flag-{{ selectedLanguage?.code }}"></span>
    {{ selectedLanguage?.name | translate }}
  </a>

  <ul class="language-list">
    <ng-container *ngFor="let language of languages">
      <li *ngIf="language?.code !== selectedLanguage?.code">
        <a class="language-list_item" (click)="selectLanguage(language)">
          <span class="flag flag-{{ language?.code }}"></span>
          <span>
            {{ language?.name | translate }}
          </span>
        </a>
      </li>
    </ng-container>
  </ul>

</div>
-->
